import { useMutation } from "react-query";
import updateSkuPoOcr from "../services/updateSkuPoOcr";

const useUpdateSkuPoOcr = () => {
  return useMutation(["update-sku-po-ocr"], updateSkuPoOcr);
};

export default useUpdateSkuPoOcr;
